import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Card, Grid, Icon, List } from "semantic-ui-react";
import { Text } from "..";

interface ISummaryCardType4 extends WithTranslation {
  title: string;
  label: string;
  fluid?: boolean;
  check?: boolean;
}

class SummaryCardType4 extends Component<ISummaryCardType4> {
  public render() {
    const { label, fluid, title, check } = this.props;
    return (
      <Card fluid={fluid}>
        <Card.Content>
          <Card.Description>
            <Grid columns={2}>
              <Grid.Row verticalAlign="middle">
                <Grid.Column textAlign="left">
                  <List relaxed="very">
                    <List.Item>
                      <Text shade={2}>{title}</Text>
                    </List.Item>
                    <List.Item>
                      <Text shade={2} size="medium">
                        {label}
                      </Text>
                    </List.Item>
                  </List>
                </Grid.Column>
                <Grid.Column textAlign="right">
                  <Icon
                    name={check ? "check" : "x"}
                    circular
                    inverted
                    color={check ? "green" : "red"}
                    size="large"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

export default withTranslation()(SummaryCardType4);
